'use strict';
var store = require('../utils/store');

var cacheKey = 'intlSessionTransactionStage';

function setTransactionStage(transactionStage) {
    store.session(cacheKey, transactionStage);
}

function getTransactionStage() {
    if (store.session.has(cacheKey)) {
        return store.session.get(cacheKey);
    }
    else {
        return 'INIT';
    }
}

module.exports = {
    setTransactionStage : setTransactionStage,
    getTransactionStage: getTransactionStage
};


//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/services/transactionStageService.js
// module id = KVib
// module chunks = 0 1 2 3 5 6